/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'truckout-trans': {
    width: 10,
    height: 9,
    viewBox: '0 0 10 9',
    data: '<path pid="0" _fill="#376F99" fill-rule="nonzero" d="M4.733 8.267l.934-.934-2.4-2.4h6V3.6h-6l2.4-2.4-.934-.933-4 4z"/>'
  }
})
